import React from 'react';

import { Platform } from 'react-native';

import LinearGradient from 'react-native-linear-gradient';

import { blackTransparent } from 'utils/colors';
import useImageRatio from 'utils/hooks/useImageRatio';

import NagraImage from 'components/NagraImage';
import {
    AspectRatio,
    ImageContentType,
    ImageSize,
    ImageType,
} from 'components/NagraImage/types';
import { getImageUrl } from 'components/NagraImage/utils';

import styles from './style';

const bottomGradientColors = [
    blackTransparent(0),
    blackTransparent(0.008),
    blackTransparent(0.03),
    blackTransparent(0.08),
    blackTransparent(0.14),
    blackTransparent(0.23),
    blackTransparent(0.33),
    blackTransparent(0.44),
    blackTransparent(0.55),
    blackTransparent(0.66),
    blackTransparent(0.76),
    blackTransparent(0.85),
    blackTransparent(0.91),
    blackTransparent(0.96),
    blackTransparent(0.99),
    '#000000',
];

export default function ProgramLogo({
    channelId,
}: {
    channelId: string | undefined;
}) {
    if (channelId != null) {
        const { height } =
            Platform.OS === 'web'
                ? ImageSize.BIG_CHANNEL_LOGO
                : ImageSize.CHANNEL_LOGO;
        const imageUrl = getImageUrl({
            contentId: channelId,
            aspect: AspectRatio.LANDSCAPE,
            contentType: ImageContentType.CHANNEL,
            imageType: ImageType.LOGO,
            height,
        });
        const { ratio: aspectRatio } = useImageRatio(imageUrl);

        return (
            <>
                <LinearGradient
                    colors={[...bottomGradientColors].reverse()}
                    angle={3.1}
                    style={styles.gradient}
                    start={{ x: 0.8, y: 0 }}
                    end={{ x: 0.75, y: 0.5 }}
                />
                <NagraImage
                    style={[
                        styles.chLogo,
                        {
                            aspectRatio,
                            height,
                        },
                    ]}
                    resizeMode="contain"
                    contentId={channelId}
                    imageType={ImageType.LOGO}
                    contentType={ImageContentType.CHANNEL}
                    aspect={AspectRatio.LANDSCAPE}
                    height={height}
                />
            </>
        );
    }

    return null;
}
